/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import info from '../Res/Icon/info.png';
import './callFeatureInfoPop.css';

const SPACING = 8;

function calcPosition(targetEl, placement) {
  const r = targetEl.getBoundingClientRect();
  const topBase = window.scrollY + r.top;
  const leftBase = window.scrollX + r.left;
  let top = 0, left = 0, transform = '';

  switch (placement) {
    case 'top':
      top = window.scrollY + r.top - SPACING;
      left = window.scrollX + r.left + r.width / 2;
      transform = 'translate(-50%, -100%)';
      break;
    case 'bottom':
      top = window.scrollY + r.bottom + SPACING;
      left = window.scrollX + r.left + r.width / 2;
      transform = 'translate(-50%, 0)';
      break;
    case 'left':
      top = window.scrollY + r.top + r.height / 2;
      left = window.scrollX + r.left - SPACING;
      transform = 'translate(-100%, -50%)';
      break;
    case 'right':
    default:
      top = window.scrollY + r.top + r.height / 2;
      left = window.scrollX + r.right + SPACING;
      transform = 'translate(0, -50%)';
      break;
  }
  return { top, left, transform };
}

const InfoPopupCallFeature = ({
  onClick,
  id,
  text,
  infoIcon = true,
  placement = 'right',  // 'top' | 'right' | 'bottom' | 'left'
  customClass = '',
}) => {
  const iconRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, transform: 'none' });

  const updatePos = useCallback(() => {
    const el = iconRef.current;
    if (!el) return;
    setPos(calcPosition(el, placement));
  }, [placement]);

  useEffect(() => {
    if (!open) return;
    updatePos();
    const onScroll = () => updatePos();
    const onResize = () => updatePos();
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onResize);
    };
  }, [open, updatePos]);

  const show = () => { setOpen(true); };
  const hide = () => { setOpen(false); };

  return (
    <>
      {infoIcon && (
        <div
          id={id}
          ref={iconRef}
          onClick={onClick}
          className="info-div"
          tabIndex={0}
          onMouseEnter={show}
          onMouseLeave={hide}
          onFocus={show}
          onBlur={hide}
          aria-describedby={`${id}-tip`}
        >
          <img className="info-icon" src={info} alt="info" />
        </div>
      )}

      {open && createPortal(
        <div
          id={`${id}-tip`}
          role="tooltip"
          className={`info-tooltip-bubble ${customClass} placement-${placement}`}
          style={{ top: pos.top, left: pos.left, transform: pos.transform }}
        >
          {text}
          <span className="info-tooltip-arrow" />
        </div>,
        document.body
      )}
    </>
  );
};

export default InfoPopupCallFeature;
